(function($) {

    $("p, h1, h2, h3, h4, h5, h6, .fade-in-text").each(function () {
        if($(this).parent('.marker')) { return; }
        $(this).attr("data-aos", "fade-up").attr("data-aos-duration", '1000');
    })

    $(window).load(function() {
        setTimeout(function() {
            AOS.refresh();
        }, 500);
    });


})( jQuery );


AOS.init({
    once: true
});